import {createStyles, Theme} from "@material-ui/core";
import {buttonContained, buttonOutlined, greyInput, styleColors, typography} from "src/main.style";

export const HolidayStyle = (theme: Theme) => createStyles({
  buttonOutlined,
  buttonContained,
  greyInput,
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  menuListItem: {
    ...typography.input,
  },
  menuItemTitle : {
    fontSize: '14px',
    fontWeight: 400,
    whiteSpace: 'normal',
    display:'flex',
    alignItems: 'center',
  },
  menuItemEnd : {
    opacity: 0.7,
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  menuItemBadge : {
    backgroundColor: styleColors.steelBlue,
    minWidth: '12px',
    height: '12px',
    fontSize: '10px',
    lineHeight: '12px',
    borderRadius: '10px',
    textAlign: 'center',
    position: 'absolute',
    /* left: 6px; */
    left: '38px',
  },
  label : {
    fontSize:'12px',
    marginLeft: '3px',
    marginTop: '24px',
  }
});




// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/Holiday.style.ts